import { Fragment } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { Box, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppButton } from "./AppButton";
import { AppDivider } from "./AppDivider";

export interface ListDialogProps extends InternalStandardProps<DialogProps> {
    open: boolean;
    onSelection: (value: number) => void;
    items: { id: number; title: string }[];
    onClose: () => void;
}

const StyledDialog = styled(Dialog)({});

const DialogWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
}));

export const ListDialog = (props: ListDialogProps) => {
    const { className, onClose, onSelection, open, items, ...rest } = props;

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = (value: number) => {
        onSelection(value);
    };

    return (
        <StyledDialog
            className={className}
            onClose={handleClose}
            open={open}
            {...rest}
        >
            <DialogWrapper>
                <DialogTitle>Select Playlist</DialogTitle>
                <AppDivider />
                <List sx={{ pt: 0 }}>
                    {items.map((i) => (
                        <Fragment key={i.id}>
                            <ListItemButton
                                onClick={() => handleListItemClick(i.id)}
                            >
                                <ListItemText primary={i.title} />
                            </ListItemButton>
                            <AppDivider />
                        </Fragment>
                    ))}
                </List>
                <Box p={1}>
                    <AppButton
                        buttonVariant="primary-filled"
                        style={{ float: "right", width: "50px" }}
                        onClick={() => handleClose()}
                    >
                        Cancel
                    </AppButton>
                </Box>
            </DialogWrapper>
        </StyledDialog>
    );
};
